var CemeteryStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService, SearchContainerHeight } from "./afla-module-strategy.service";
import _ from "underscore";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ModuleConfig } from "../../models/module-config.model";
import { SharedConstants } from "../../constants/shared.constants";
import { ApplicationSearchService } from "../../../tabs/applications/shared/application-search.service";
import { catchError, distinctUntilChanged, map } from "rxjs/operators";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { BehaviorSubject, throwError } from "rxjs";
import { AppControllerService } from "../../../app-controller.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { AlertType } from "../../models/alert";
import { ApplicationSearchConstants } from "../../../tabs/applications/application-search/application-search-constants";
import { ODataAction } from "../odata-query/odata-action.model";
import { RequestStatusService } from "../request-status/request-status.service";
import { ActivatedRoute, Router } from "@angular/router";
import { RecipientSelectService } from "../../components/recipient-select/shared/service/recipient-select.service";
import { SearchOptionsConstants } from "../../../core/settings/components/search-options/search-options-constants";
import { ApiSearchOptionConstants } from "../../constants/api-constants/api-search-option.constants";
import { ViewApplicationDetailsCmComponent } from "../../../application/view-application/modules/cm/view-application-details-cm/view-application-details-cm.component";
import { ViewApplicationDeceasedCmComponent } from "../../../application/view-application/modules/cm/view-application-deceased-cm/view-application-deceased-cm.component";
import { ViewApplicationFamilyCmComponent } from "../../../application/view-application/modules/cm/view-application-family-cm/view-application-family-cm.component";
import { CreateApplicationDeceasedCmComponent } from "../../../application/create-application/modules/cm/create-application-deceased-cm/create-application-deceased-cm.component";
import { CreateApplicationFamilyCmComponent } from "../../../application/create-application/modules/cm/create-application-family-cm/create-application-family-cm.component";
import { CreateApplicationDetailsCmComponent } from "../../../application/create-application/modules/cm/create-application-details-cm/create-application-details-cm.component";
import { ApiCemeteryConstants } from "../../constants/api-constants/api-cemetery.constants";
import { SearchAssignedToComponent } from "../../../tabs/applications/application-search/search-assigned-to/search-assigned-to.component";
import { SearchCreatedDateComponent } from "../../../tabs/applications/application-search/search-created-date/search-created-date.component";
import { SearchApplicantInfoComponent } from "../../../tabs/applications/application-search/search-applicant-info/search-applicant-info.component";
import { SearchStatusComponent } from "../../../tabs/applications/application-search/search-status/search-status.component";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import { SearchDeceasedInfoCmComponent } from "../../../tabs/applications/application-search/modules/cm/search-deceased-info-cm/search-deceased-info-cm.component";
import { SearchFuneralParlourComponent } from "../../../tabs/applications/application-search/modules/cm/search-funeral-parlour/search-funeral-parlour.component";
import { ApiProxyConstants } from "../../constants/api-constants/api-proxy.constants";
import { SearchFamilyComponent } from "../../../tabs/applications/application-search/modules/cm/search-family/search-family.component";
import RecipientUtils from "../../utils/recipient-utils";
import { ViewApplicationGraveCmComponent } from "../../../application/view-application/modules/cm/view-application-grave-cm/view-application-grave-cm.component";
import { EsriDataTypeEnum } from "../../models/esri-data-type-enum";
import { SearchStartDateComponent } from "../../../tabs/applications/application-search/search-start-date/search-start-date.component";
import { SearchCategoryComponent } from "../../../tabs/applications/application-search/search-category/search-category.component";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { ApplicationsRoutingConstants } from "../../../tabs/applications/applications-routing.constants";
import { ModulePrefix } from "../../models/module-prefix.model";
// Not to be sorted!!!! ==> Already in correct sort order
// Please do not rename the enums ==> it will break the SearchOptions Field?Column Settings! Labels can be changed without any impact.
export var CemeterySearchOptions;
(function (CemeterySearchOptions) {
    CemeterySearchOptions["ReferenceNumber"] = "Reference Number";
    CemeterySearchOptions["MyApplications"] = "My Applications";
    CemeterySearchOptions["ApplicantInfo"] = "Applicant Information";
    CemeterySearchOptions["AppID"] = "Application ID";
    CemeterySearchOptions["ApplicationStatus"] = "Application Status";
    CemeterySearchOptions["ApplicationCategory"] = "Application Category";
    CemeterySearchOptions["ApplicationsWithoutStartDate"] = "Applications Without Start Date";
    CemeterySearchOptions["AssignedToUsers"] = "Assigned to";
    CemeterySearchOptions["UnassignedApplications"] = "Unassigned Applications";
    CemeterySearchOptions["BurialOrderNumber"] = "Burial Order Number";
    CemeterySearchOptions["CreatedDate"] = "Created Date";
    CemeterySearchOptions["CreatedDateRange"] = "Created Date Range";
    CemeterySearchOptions["StartDate"] = "Started Date";
    CemeterySearchOptions["StartDateRange"] = "Started Date Range";
    CemeterySearchOptions["DaysUntilExpired"] = "Days until Expired";
    CemeterySearchOptions["DeceasedDetails"] = "Deceased Details";
    CemeterySearchOptions["FamilyDetails"] = "Family Details";
    CemeterySearchOptions["FuneralParlour"] = "Funeral Parlour";
    CemeterySearchOptions["PercentageComplete"] = "Percentage Complete";
    CemeterySearchOptions["TimeoutStatus"] = "Timeout Status";
    CemeterySearchOptions["JobID"] = "Job ID";
})(CemeterySearchOptions || (CemeterySearchOptions = {}));
// TODO these columns will change depending on how columns have been configured. This is the default list
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    //Agent = "Agent",
    ApplicationHeadingEnum["BurialDate"] = "Burial Date";
    ApplicationHeadingEnum["DeceasedDateOfBirth"] = "Deceased Date of Birth";
    ApplicationHeadingEnum["DeceasedSerialNo"] = "Serial No";
    ApplicationHeadingEnum["BurialOrderNumber"] = "Burial Order No";
    ApplicationHeadingEnum["StartDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
// @ts-ignore
export const applicationHeadingLookup = new Map([
    [ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationHeadingEnum.Applicant, "applicant"],
    //[ApplicationHeadingEnum.Agent, "agent"],
    [ApplicationHeadingEnum.BurialDate, "burialDate"],
    [ApplicationHeadingEnum.DeceasedDateOfBirth, "dateOfBirth"],
    [ApplicationHeadingEnum.DeceasedSerialNo, "serialNo"],
    [ApplicationHeadingEnum.BurialOrderNumber, "burialOrderNumber"],
    [ApplicationHeadingEnum.StartDate, "startDate"],
    [ApplicationHeadingEnum.ApplicationStatus, "phase"],
    [ApplicationHeadingEnum.DaysLeft, "daysLeft"],
    [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],
]);
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    //Agent = "Agent",
    ApplicationSummaryColumnsEnum["StartDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Phase";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([
    [ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationSummaryColumnsEnum.Applicant, "applicant"],
    //[ApplicationSummaryColumnsEnum.Agent, "agent"],
    [ApplicationSummaryColumnsEnum.StartDate, "startDate"],
    [ApplicationSummaryColumnsEnum.Phase, "phase"],
    [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"],
    [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"],
]);
export const CemeterySearchQueryLookup = new Map([
    [CemeterySearchOptions.AppID, "appId"],
    [CemeterySearchOptions.ReferenceNumber, "referenceNumber"],
    [CemeterySearchOptions.BurialOrderNumber, "burialOrderNumber"],
    [CemeterySearchOptions.JobID, "jobId"]
]);
export const CemeteryAdditionalSearchOptions = [CemeterySearchOptions.MyApplications,
    CemeterySearchOptions.AssignedToUsers,
    CemeterySearchOptions.UnassignedApplications];
export const CemeteryDateSearchOptions = new Map([
    [CemeterySearchOptions.CreatedDate, 1],
    [CemeterySearchOptions.CreatedDateRange, 2],
    [CemeterySearchOptions.DeceasedDetails, 1]
]);
export const CemeteryStartDateRangeSearchOptions = new Map([
    [CemeterySearchOptions.StartDate, 1],
    [CemeterySearchOptions.StartDateRange, 2]
]);
export const CemeteryStatusSearchOptions = new Map([
    [CemeterySearchOptions.ApplicationStatus, ApplicationSearchConstants.STATUS],
    [CemeterySearchOptions.PercentageComplete, ApplicationSearchConstants.PERCENT_COMPLETE],
    [CemeterySearchOptions.DaysUntilExpired, ApplicationSearchConstants.DAYS_UNTIL_EXPIRED],
    [CemeterySearchOptions.TimeoutStatus, ApplicationSearchConstants.TIMEOUT_STATUS],
]);
export const CemeterySearchOptionClientHeight = new Map([
    [CemeterySearchOptions.ReferenceNumber, SearchContainerHeight.Simple + SearchContainerHeight.Cemetery],
    [CemeterySearchOptions.MyApplications, SearchContainerHeight.Simple + SearchContainerHeight.Cemetery],
    [CemeterySearchOptions.AppID, SearchContainerHeight.Simple + SearchContainerHeight.Cemetery],
    [CemeterySearchOptions.BurialOrderNumber, SearchContainerHeight.Simple + SearchContainerHeight.Cemetery],
    [CemeterySearchOptions.ApplicationStatus, SearchContainerHeight.SingleLine + SearchContainerHeight.Cemetery],
    [CemeterySearchOptions.PercentageComplete, SearchContainerHeight.SingleLine + SearchContainerHeight.Cemetery],
    [CemeterySearchOptions.DaysUntilExpired, SearchContainerHeight.SingleLine + SearchContainerHeight.Cemetery],
    [CemeterySearchOptions.TimeoutStatus, SearchContainerHeight.SingleLine + SearchContainerHeight.Cemetery],
    [CemeterySearchOptions.CreatedDate, SearchContainerHeight.SingleLine + SearchContainerHeight.Cemetery],
    [CemeterySearchOptions.AssignedToUsers, SearchContainerHeight.SingleLine + SearchContainerHeight.Cemetery],
    [CemeterySearchOptions.CreatedDateRange, SearchContainerHeight.SingleLine + SearchContainerHeight.Cemetery],
    //[CemeterySearchOptions.ApplicantAgent, SearchContainerHeight.Extended + SearchContainerHeight.Cemetery],
    [CemeterySearchOptions.ApplicantInfo, SearchContainerHeight.Extended + SearchContainerHeight.Cemetery],
    [CemeterySearchOptions.DeceasedDetails, SearchContainerHeight.Extended + SearchContainerHeight.Cemetery],
    [CemeterySearchOptions.FamilyDetails, SearchContainerHeight.Extended - SearchContainerHeight.Cemetery],
    [CemeterySearchOptions.FuneralParlour, SearchContainerHeight.Extended + SearchContainerHeight.Cemetery],
]);
// TODO: Other tables?
// IMPORTANT: these values much match the DB table names and the Property names used by oData entity for TownPlanning
export var CemeterySearchOptionTableListEnum;
(function (CemeterySearchOptionTableListEnum) {
    CemeterySearchOptionTableListEnum["Application"] = "CM_APPLICATION|Application";
    CemeterySearchOptionTableListEnum["Deceased"] = "CM_DECEASED|Deceased";
    CemeterySearchOptionTableListEnum["DeceasedNames"] = "CM_DECEASEDNAME|DeceasedNames";
    CemeterySearchOptionTableListEnum["Status"] = "AFLA_APPLICATIONSTATUS|Status";
    CemeterySearchOptionTableListEnum["Applicant"] = "AFLA_Recipient|Applicant";
    CemeterySearchOptionTableListEnum["ApplicantAgent"] = "AFLA_Recipient|ApplicantAgent";
    CemeterySearchOptionTableListEnum["Family"] = "AFLA_Recipient|Family";
    CemeterySearchOptionTableListEnum["FuneralParlour"] = "AFLA_Recipient|FuneralParlour";
})(CemeterySearchOptionTableListEnum || (CemeterySearchOptionTableListEnum = {}));
export const CMExpandListForApplicationSearch = ApplicationSearchConstants.APP_SEARCH_EXPAND_LIST_CM;
export const CMExpandListForApplicationSearchWithFamily = ApplicationSearchConstants.APP_SEARCH_EXPAND_FULL_LIST_CM;
export const CMTableNameListForSearchOptions = CemeterySearchOptionTableListEnum.Application
    + "," + CemeterySearchOptionTableListEnum.Deceased
    + "," + CemeterySearchOptionTableListEnum.DeceasedNames
    + "," + CemeterySearchOptionTableListEnum.Status
    + "," + CemeterySearchOptionTableListEnum.Applicant
    + "," + CemeterySearchOptionTableListEnum.ApplicantAgent
    + "," + CemeterySearchOptionTableListEnum.Family
    + "," + CemeterySearchOptionTableListEnum.FuneralParlour;
export var CreateApplicationMenuHeadings;
(function (CreateApplicationMenuHeadings) {
    CreateApplicationMenuHeadings["Details"] = "Details";
    CreateApplicationMenuHeadings["ApplicantAgent"] = "Applicant / agent";
    CreateApplicationMenuHeadings["Deceased"] = "Deceased details";
    CreateApplicationMenuHeadings["Family"] = "Family";
    CreateApplicationMenuHeadings["Notes"] = "Notes";
})(CreateApplicationMenuHeadings || (CreateApplicationMenuHeadings = {}));
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Details"] = "Details";
    ViewApplicationMenuHeadings["ApplicantAgent"] = "Applicant / applicant agent";
    ViewApplicationMenuHeadings["Family"] = "Family";
    ViewApplicationMenuHeadings["Deceased"] = "Deceased details";
    ViewApplicationMenuHeadings["Grave"] = "Grave";
    ViewApplicationMenuHeadings["Assessment"] = "Assessment";
    ViewApplicationMenuHeadings["Attachments"] = "Attachments";
    ViewApplicationMenuHeadings["Checklist"] = "Checklist";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Conditions"] = "Conditions";
    ViewApplicationMenuHeadings["History"] = "History";
    ViewApplicationMenuHeadings["Invoices"] = "Invoices";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    ViewApplicationMenuHeadings["RelatedApplicationSearch"] = "Related applications";
    ViewApplicationMenuHeadings["RequiredDocumentsChecklist"] = "Required documents checklist";
    ViewApplicationMenuHeadings["Result"] = "Result";
    ViewApplicationMenuHeadings["ScheduledReminders"] = "Scheduled Reminders";
    ViewApplicationMenuHeadings["Status"] = "Status";
    ViewApplicationMenuHeadings["StepManagement"] = "Step management";
    ViewApplicationMenuHeadings["Survey123"] = "Survey123";
    ViewApplicationMenuHeadings["Timeouts"] = "Timeouts";
    ViewApplicationMenuHeadings["Team"] = "Team";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export var SettingsMenuHeadings;
(function (SettingsMenuHeadings) {
    SettingsMenuHeadings["AvailableSurvey123s"] = "Available survey123s";
    SettingsMenuHeadings["Lookups"] = "Lookups";
    SettingsMenuHeadings["MapConfig"] = "Map services";
    SettingsMenuHeadings["NonWorkingDays"] = "Non-working days";
    SettingsMenuHeadings["AttachmentTypes"] = "Attachment types";
    SettingsMenuHeadings["Recipients"] = "Recipients";
    SettingsMenuHeadings["RecipientGroups"] = "Recipient groups";
    SettingsMenuHeadings["Reports"] = "Reports";
    SettingsMenuHeadings["StepMetaData"] = "Step metadata";
    SettingsMenuHeadings["Tariffs"] = "Tariffs";
    SettingsMenuHeadings["Templates"] = "Templates";
    SettingsMenuHeadings["NotificationTemplates"] = "Notification templates";
    SettingsMenuHeadings["ModuleRoles"] = "Module roles";
    SettingsMenuHeadings["AFLAPortalDocuments"] = "Afla portal documents";
    SettingsMenuHeadings["AFLAPortalUpdateOwners"] = "Afla portal update owners";
    SettingsMenuHeadings["SearchOptions"] = "Search options";
    SettingsMenuHeadings["SearchSettings"] = "Search settings";
    SettingsMenuHeadings["BackupRestore"] = "Backup and restore";
    SettingsMenuHeadings["ArcGISItems"] = "ArcGIS items";
    SettingsMenuHeadings["AFLAPortalMessagesAndPages"] = "AFLA portal messages and pages";
    SettingsMenuHeadings["InvoiceTemplates"] = "Invoice templates";
    SettingsMenuHeadings["Stamps"] = "Stamps";
    SettingsMenuHeadings["ApplicationWorkflowUpgrade"] = "Application workflow upgrade";
})(SettingsMenuHeadings || (SettingsMenuHeadings = {}));
export const CmRequiredMapFields = [{
        mapName: "Property",
        fields: [
            { name: "OBJECTID", type: EsriDataTypeEnum.oid },
            { name: "SgCode", type: EsriDataTypeEnum.string },
            { name: "ErfNo", type: EsriDataTypeEnum.string },
            { name: "FarmNo", type: EsriDataTypeEnum.string },
            { name: "PtnNum", type: EsriDataTypeEnum.string },
            { name: "Allotment", type: EsriDataTypeEnum.string },
            { name: "PropertyDescription", type: EsriDataTypeEnum.string },
            { name: "Address", type: EsriDataTypeEnum.string },
            { name: "TotalValue", type: EsriDataTypeEnum.integer },
            { name: "HasGeometry", type: EsriDataTypeEnum.integer },
            { name: "ErfSize", type: EsriDataTypeEnum.integer },
            { name: "TitleDeed", type: EsriDataTypeEnum.string },
            { name: "SectionalTitleSchemeID", type: EsriDataTypeEnum.string },
            { name: "Type", type: EsriDataTypeEnum.string },
            { name: "LegalStatus", type: EsriDataTypeEnum.string },
            { name: "FloorNo", type: EsriDataTypeEnum.string },
            { name: "FloorName", type: EsriDataTypeEnum.string },
            { name: "SgDiagramNo", type: EsriDataTypeEnum.string },
            { name: "UnitNumber", type: EsriDataTypeEnum.integer },
            { name: "Registered", type: EsriDataTypeEnum.smallInteger },
            { name: "SgCodeExternal", type: EsriDataTypeEnum.string },
            { name: "PremiseID", type: EsriDataTypeEnum.string },
            { name: "AccountNo", type: EsriDataTypeEnum.string },
            { name: "ZoningCategory", type: EsriDataTypeEnum.string },
            { name: "Shape", type: EsriDataTypeEnum.geometry },
            { name: "Shape_Area", type: EsriDataTypeEnum.double },
            { name: "Shape_Length", type: EsriDataTypeEnum.double }
        ]
    }];
let CemeteryStrategyService = class CemeteryStrategyService extends AflaModuleStrategyService {
    static { CemeteryStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    http;
    appController;
    router;
    recipientSelectService;
    route;
    buildingUseSearchOptions;
    overdueApplicationExpandFields = "status, applicant";
    showApplicantAgentForModule = false;
    requiredMapFields;
    createApplicationMenuHeadings;
    overrideMapDefault = {
        popup: {
            bufferDistance: 0
        }
    };
    viewApplicationComponentLookup;
    name = ModuleConfig.Cemetery;
    modulePrefix = ModulePrefix.Cemetery;
    searchQueryLookup;
    defaultSearchColumns;
    searchOptions;
    applicationEndpoint;
    extendedSimpleSearchOptions;
    dateSearchOptions;
    RangeSearchOptions;
    statusSearchOptions;
    groupSearchOptions;
    clientHeightMap;
    createApplicationComponentLookup;
    advancedSearchComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    // column headers are dynamic
    applicationTableColumnMap = new BehaviorSubject(null);
    applicationTableColumnMapObservable;
    applicationServiceUrl = ApiCemeteryConstants.URL;
    form;
    lookups = new Map();
    userId;
    moduleUsers;
    expandListForApplicationSearch = CMExpandListForApplicationSearch;
    expandListForApplicationSearchFullList = CMExpandListForApplicationSearchWithFamily;
    searchOptionTableNameList = CMTableNameListForSearchOptions;
    customApplicationTableColumnMap;
    selectedSearchOptionLookup;
    searchOptionsWithCustomColumns = [];
    searchOptionsFieldList;
    searchOptionsMap;
    isPrevSavedSearch = false;
    aflaPortalConfigurableMessages = [
        "Welcome help",
        "Applicant help",
        "Welcome page",
        "Deceased details help",
        "Burial details help",
        "Family member details help",
        "Applicant help",
        "Agent help",
        "Funeral parlour help",
        "Required documentation help",
        "Notes help",
        "Summary help",
        "Create application status page",
        "View application status page",
        "Communication help"
    ];
    setApplicantAndApplicantAgentAction = ApiCemeteryConstants.FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT;
    settingsMenuHeadings;
    settingsComponentLookup;
    propertiesPageHeading = "Graves";
    moduleRequiredMaps;
    stampOptions = [];
    previousApplication = null;
    statusColumn = "status/ workflowSection";
    createApplicationSubscription;
    constructor(saShortDatePipe, applicationSearchService, appControllerService, oDataQueryService, requestStatusService, http, appController, router, recipientSelectService, route) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.recipientSelectService = recipientSelectService;
        this.route = route;
        this.initForm();
        this.applicationEndpoint = ApiApplicationSearchConstants.CEMETERY_ENDPOINT;
        this.createApplicationMenuHeadings = CreateApplicationMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        this.settingsMenuHeadings = SettingsMenuHeadings;
        this.moduleRequiredMaps = ["Properties"];
        this.requiredMapFields = CmRequiredMapFields;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    // the format for a column filter on an child table is:
    //    EQUALS ==> applicantAgent/any(m:m/name eq 'xxxx')
    //    CONTAINS with tolower ==> applicantAgent/any(b:contains(tolower(b/name),'xxxx'))
    static buildColumnFilter(text, filter) {
        const column = filter ? filter : ApplicationSearchConstants.DEFAULT_SEARCH;
        return `contains(tolower(cast(${column.trim()},'Edm.String')),'${text.trim().toLowerCase()}') and eLodgementComplete eq true`;
    }
    static buildExpand(params, top, useCompleteListForSearch) {
        params = params.set(ODataAction.Expand, useCompleteListForSearch ? CMExpandListForApplicationSearchWithFamily : CMExpandListForApplicationSearch);
        params = params.set(ODataAction.Top, top);
        params = params.set(ODataAction.OrderBy, "startDate ne null desc, startDate desc, appId desc");
        return params;
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    buildListFilter(list, column) {
        const params = CemeteryStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue, true);
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    getStatusForModule(moduleID, statusField) {
        return this.applicationSearchService.getStatusForModule(moduleID, statusField);
    }
    getUsersForModule(moduleID) {
        return this.applicationSearchService.getUsersForModule(moduleID);
    }
    initializeSearchQueryLookup() {
        this.searchQueryLookup = CemeterySearchQueryLookup;
    }
    initializeAdditionalSearchLookup() {
        this.extendedSimpleSearchOptions = CemeteryAdditionalSearchOptions;
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    initializeSearchOptionsLookup() {
        this.searchOptions = new Array();
        this.searchOptions.push(..._.values(CemeterySearchOptions));
        // this is used for the SearchOptions settings
        this.searchOptionsMap = new Map();
        for (const [key, value] of Object.entries(CemeterySearchOptions)) {
            this.searchOptionsMap.set(key, value);
        }
        // default column list if search option types does not have a default
        this.defaultSearchColumns = applicationHeadingLookup;
    }
    initializeDateSearchOptions() {
        this.dateSearchOptions = CemeteryDateSearchOptions;
        this.RangeSearchOptions = CemeteryStartDateRangeSearchOptions;
    }
    initializeStatusSearchOptions() {
        this.statusSearchOptions = CemeteryStatusSearchOptions;
        this.clientHeightMap = CemeterySearchOptionClientHeight;
    }
    initializeGroupSearchOptions = () => {
    };
    getFieldListForSearchOptions(moduleId) {
        const params = {
            $filter: CemeteryStrategyService_1.buildModuleIDFilter(moduleId, this.applicationSearchService.optionCheckbox),
            $expand: SearchOptionsConstants.SEARCH_OPTIONS_EXPAND,
            $orderby: SearchOptionsConstants.SEARCH_OPTIONS_COLUMNS_ORDERBY
        };
        const url = `${ApiSearchOptionConstants.URL}`;
        return this.http.get(url, { params }).pipe(map((response) => {
            this.searchOptionsWithCustomColumns = [];
            this.searchOptionsFieldList = response.value;
            this.searchOptionsFieldList.forEach((option) => {
                const searchOptionLookup = this.getSearchOptionLookup(option.searchOption);
                // @ts-ignore
                if (this.searchOptionsWithCustomColumns.indexOf(searchOptionLookup) < 0) { // @ts-ignore
                    this.searchOptionsWithCustomColumns.push(searchOptionLookup);
                }
            });
            return response.value;
        }));
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            applicant: CemeteryStrategyService_1.getRecipientName(CemeteryStrategyService_1.getFirstRecipient(application.applicant)),
            agent: CemeteryStrategyService_1.getRecipientName(CemeteryStrategyService_1.getFirstRecipient(application.applicantAgent)),
            startDate: application.createdDate !== null
                ? this.saShortDatePipe.transform(application.startDate)
                : "",
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null
                ? this.saShortDatePipe.transform(application.lastEditedDate)
                : "",
            moduleId: application.moduleId,
            burialDate: application.burialDate !== null
                ? this.saShortDatePipe.transform(application.burialDate)
                : "",
            dateOfBirth: application.deceased != null && application.deceased.length > 0 && application.deceased[0].applicationId && application.deceased[0].dateOfBirth !== null
                ? this.saShortDatePipe.transform(application.deceased[0].dateOfBirth)
                : "",
            burialOrderNumber: application.deceased != null && application.deceased.length > 0 && application.deceased[0].burialOrderNumber !== null
                ? application.deceased[0].burialOrderNumber
                : "",
            serialNo: application.deceased != null && application.deceased.length > 0 && application.deceased[0].serialNo !== null
                ? application.deceased[0].serialNo
                : "",
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getApplicationFieldValue(application, appGroup, fieldName) {
        let fieldValue;
        for (const [key, value] of Object.entries(application)) {
            if (!fieldValue && appGroup.toLowerCase() === "application") {
                if (key.toLowerCase() === fieldName.toLowerCase()) {
                    fieldValue = value;
                    break;
                }
            }
            else {
                if (!fieldValue
                    && key.toLowerCase() === appGroup.toLowerCase()) {
                    // some applications may have null lower order properties e.g. Status
                    if (value) {
                        const group = value[0] ? value[0] : value;
                        for (const [groupKey, groupValue] of Object.entries(group)) {
                            switch (appGroup.toLowerCase()) {
                                case "applicant":
                                case "deceased":
                                case "funeralparlour":
                                case "applicantagent":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = groupValue;
                                    }
                                    break;
                                case "status":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        switch (fieldName.toLowerCase()) {
                                            case "assignedto":
                                            case "createdby":
                                                // these fields will be handled in the user section below
                                                break;
                                            default:
                                                fieldValue = groupValue;
                                                break;
                                        }
                                        break;
                                    }
                                    break;
                                // the following properties can be multiple values - we cannot use ObjectUtils.getCommaSeparatedValuesFromListForKey because it is case sensitive
                                case "family":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = fieldValue ? fieldValue += ", " + groupValue : groupValue;
                                    }
                                    break;
                            }
                        }
                    }
                }
                if (fieldValue)
                    break;
            }
        }
        // If we need to use a 3rd level table that is referenced
        if (!fieldValue && appGroup.toLowerCase() === "deceasednames") {
            if (application.deceased != null && application.deceased.length > 0 && application.deceased[0].deceasedNames.length > 0) {
                application.deceased[0].deceasedNames.forEach((deceasedName) => {
                    for (const [groupKey, groupValue] of Object.entries(deceasedName)) {
                        if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                            // the following properties can be multiple values - we cannot use ObjectUtils.getCommaSeparatedValuesFromListForKey because it is case sensitive
                            fieldValue = fieldValue ? fieldValue += ", " + groupValue : groupValue;
                        }
                    }
                });
            }
        }
        if (!fieldValue)
            fieldValue = "";
        if (fieldName.toLowerCase().endsWith("date") || fieldName.toLowerCase().startsWith("date")) {
            switch (fieldName.toLowerCase()) {
                case "dateofbirth":
                    fieldValue = fieldValue ? application.deceased.length > 0 ? this.saShortDatePipe.transform(application.deceased[0].dateOfBirth) : "" : "";
                    break;
                case "dateofdeath":
                    fieldValue = fieldValue ? application.deceased.length > 0 ? this.saShortDatePipe.transform(application.deceased[0].dateOfDeath) : "" : "";
                    break;
                default:
                    fieldValue = fieldValue ? this.saShortDatePipe.transform(fieldValue) : "";
            }
        }
        else {
            switch (fieldName.toLowerCase()) {
                case "lasteditedby":
                case "lastediteduser":
                    fieldValue = this.getUserName(application.lastEditedUser);
                    break;
                case "createduserid":
                case "createdby":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.createdBy) : "";
                    break;
                case "assignedto":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.assignedTo) : "";
                    break;
                case "createduserid":
                    fieldValue = this.getUserName(application.createdSystemUser);
                    break;
            }
        }
        return fieldValue;
    }
    customColumnSearchModel(application, columnList, isPrevSavedSearch = false) {
        // need to reset the column map if the search options customised columns have been updated
        if ((this.customApplicationTableColumnMap.size !== 0 && columnList.length !== this.customApplicationTableColumnMap.size)
            || isPrevSavedSearch) {
            this.customApplicationTableColumnMap.clear();
            this.isPrevSavedSearch = false;
        }
        let resetHeadings = this.customApplicationTableColumnMap.size === 0;
        const appDetails = {};
        if (columnList.length > 0) {
            columnList.forEach((column) => {
                const fieldAlias = column.moduleField.fieldAlias;
                let fieldName = column.moduleField.fieldName;
                const tableLookup = this.getSearchOptionLookup(`${column.moduleField.tableAlias}`);
                const appGroup = this.getApplicationTableProperty(`${column.moduleField.tableName}|${tableLookup}`);
                const appProperty = `${appGroup.toLowerCase()}${fieldName.toLowerCase()}`;
                // "status" refers to the Status object, so the fieldname has an alias in ICmApplication
                if (appGroup.toLowerCase() === "application" && fieldName.toLowerCase() === "status")
                    fieldName = "statusField";
                appDetails[appProperty] = this.getApplicationFieldValue(application, tableLookup, fieldName);
                if (resetHeadings)
                    this.customApplicationTableColumnMap.set(fieldAlias, appProperty);
            });
            // standard fields to add in case the user did not add them
            // @ts-ignore
            appDetails.id = application.id;
            // @ts-ignore
            appDetails.moduleId = application.moduleId;
            // @ts-ignore
            appDetails.jobId = application.jobId;
            // @ts-ignore
            appDetails.appId = application.appId;
            // only set the headings once for the search
            if (resetHeadings) {
                this.changeAppTableColumnMap(this.customApplicationTableColumnMap);
                resetHeadings = false;
            }
            return appDetails;
        }
        else
            return this.defaultSearchModel(application);
    }
    getApplicationTableProperty(tableName) {
        let property = "";
        for (const [tableKey, tableValue] of Object.entries(CemeterySearchOptionTableListEnum)) {
            if (tableValue.toLowerCase() === tableName.toLowerCase()) {
                // @ts-ignore
                property = tableKey;
                break;
            }
        }
        return property;
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getCustomApplicationSearchModel(searchOptionLookup) {
        // identify columnList for specific search option
        return this.applicationSearchService.getSearchOptionColumnList(this, searchOptionLookup);
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        if (application) {
            return this.defaultSearchModel(application);
        }
    }
    initializeSettingsComponents() {
        this.settingsComponentLookup = new Map([]);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [
                ViewApplicationMenuHeadings.Details,
                ViewApplicationDetailsCmComponent,
            ],
            [
                ViewApplicationMenuHeadings.Deceased,
                ViewApplicationDeceasedCmComponent,
            ],
            [
                ViewApplicationMenuHeadings.Family,
                ViewApplicationFamilyCmComponent,
            ],
            [
                ViewApplicationMenuHeadings.Grave,
                ViewApplicationGraveCmComponent,
            ]
        ]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [
                CreateApplicationMenuHeadings.Details,
                CreateApplicationDetailsCmComponent,
            ],
            [
                CreateApplicationMenuHeadings.Deceased,
                CreateApplicationDeceasedCmComponent,
            ],
            [
                CreateApplicationMenuHeadings.Family,
                CreateApplicationFamilyCmComponent,
            ]
        ]);
    }
    initializeAdvancedApplicationSearchComponents() {
        this.advancedSearchComponentLookup = new Map([
            //[CemeterySearchOptions.ApplicantAgent, SearchApplicantAgentComponent],
            [CemeterySearchOptions.AssignedToUsers, SearchAssignedToComponent],
            [CemeterySearchOptions.CreatedDate, SearchCreatedDateComponent],
            [CemeterySearchOptions.CreatedDateRange, SearchCreatedDateComponent],
            [CemeterySearchOptions.StartDate, SearchStartDateComponent],
            [CemeterySearchOptions.StartDateRange, SearchStartDateComponent],
            [CemeterySearchOptions.ApplicantInfo, SearchApplicantInfoComponent],
            [CemeterySearchOptions.PercentageComplete, SearchStatusComponent],
            [CemeterySearchOptions.ApplicationStatus, SearchStatusComponent],
            [CemeterySearchOptions.ApplicationCategory, SearchCategoryComponent],
            [CemeterySearchOptions.TimeoutStatus, SearchStatusComponent],
            [CemeterySearchOptions.DaysUntilExpired, SearchStatusComponent],
            [CemeterySearchOptions.DeceasedDetails, SearchDeceasedInfoCmComponent],
            [CemeterySearchOptions.FuneralParlour, SearchFuneralParlourComponent],
            [CemeterySearchOptions.FamilyDetails, SearchFamilyComponent],
        ]);
    }
    getSearchOptionLookup(selectedSearchOption) {
        const keys = [...this.searchOptionsMap.entries()]
            .filter(({ 1: v }) => v === selectedSearchOption)
            .map(([k]) => k);
        return keys.length > 0 ? keys[0].toString() : selectedSearchOption;
    }
    initializeApplicationTableColumnMap() {
        this.applicationTableColumnMapObservable = this.applicationTableColumnMap.asObservable();
        this.changeAppTableColumnMap(this.customApplicationTableColumnMap
            ? this.customApplicationTableColumnMap : applicationHeadingLookup);
    }
    changeAppTableColumnMap(tableColumnMap) {
        this.applicationTableColumnMap.next(tableColumnMap);
    }
    doSearchApplicationsByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsByResponsiblePerson(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchUnassignedApplications(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUnassignedApplication(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsWithoutStartDate(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsWithoutStartDate(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "appId", true, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doApplicationSearch(search, moduleID, pageHeading, withDefaultColumns, useCompleteListForSearch) {
        const column = this.getEntityColumn(search.column);
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsUsingSimpleSearch(search.text, column, this, moduleID, withDefaultColumns, useCompleteListForSearch)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    // Cemetery searches need the ModuleId as a separate parameter when "Family" is included in the expand list
    getApplicationsQuery(params, useFullTableList) {
        // @ts-ignore
        const update = params.updates === null ? true : false;
        // @ts-ignore
        if (update && params.get("$expand").indexOf(ApplicationSearchConstants.FAMILY) > -1) {
            return this.getApplicationsQueryExtended(params, this.buildCMSExtendedEndpoint());
        }
        else {
            return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
        }
    }
    getApplicationsQueryExtended(params, extendedEndPoint) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint, extendedEndPoint), { params });
    }
    getApplicationsSearchRequestWithAdditionalFilters(text, filter, moduleID, useCompleteListForSearch) {
        let params = CemeteryStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, AflaModuleStrategyService.buildModuleIDFilter(moduleID), CemeteryStrategyService_1.buildColumnFilter(text, filter));
        return this.getApplicationsQuery(params);
    }
    buildApplicationSearchBaseRequest(moduleID, useCompleteListForSearch) {
        let params = CemeteryStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue, useCompleteListForSearch);
        params = this.oDataQueryService.filter(params, CemeteryStrategyService_1.buildModuleIDFilter(moduleID, this.applicationSearchService.optionCheckbox), CemeteryStrategyService_1.showCompleteApplications());
        return this.getApplicationsQuery(params);
    }
    buildDashboardApplicationsSearch(moduleID, dashboardFilter) {
        let params = CemeteryStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.applicationSearchService.dashboardSearch(params, dashboardFilter, moduleID);
        return this.getApplicationsQuery(params);
    }
    createApplication() {
        this.requestStatusService.showBusySpinner("CreateCmApplication");
        const application = this.buildApplication();
        this.createApplicationSubscription =
            this.postApplicationService(application)
                .subscribe({
                next: (savedApplication) => {
                    this.appController.showMessage(CemeteryStrategyService_1.successMessage(savedApplication.jobId), AlertType.Success);
                    this.form
                        .get("deceasedForm")
                        .get("deceasedNames").clear();
                    this.form.get("noteForm").get("notes").clear();
                    this.resetForm();
                    this.requestStatusService.removeBusySpinner("CreateCmApplication");
                    this.router.navigate([
                        AppRoutingConstants.ROUTE_SEPERATOR + ApplicationsRoutingConstants.REFRESH_ROUTE,
                        {
                            jobId: savedApplication.jobId,
                            moduleId: this.appController.selectedModuleID,
                            type: ApplicationsRoutingConstants.REFRESH_VIEW_APPLICATION_ROUTE
                        }
                    ]);
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("CreateCmApplication");
                    this.appController.handleServerErrorMessage("" +
                        "application", error, CRUDOperation.Add);
                }
            });
    }
    getApplicationGeometries(jobID, moduleID) {
        const params = {
            $select: "shape, graves",
            $expand: "graves",
            $filter: `jobId eq ${+jobID} and moduleId eq ${+moduleID}`
        };
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    resetForm() {
        this.form.reset();
        this.form.get("deceasedForm").get("nationality").setValue(SharedConstants.DEFAULT_COUNTRY);
    }
    postApplicationService(params) {
        return this.http.post(ApiCemeteryConstants.URL, params);
    }
    getSelectedApplicationSummaryExpand() {
        return "status, applicant, applicant($expand=groups), applicantAgent, lastEditedUser, graves";
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_CM_APPLICATIONS_BY_USER;
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_CREATED_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_CM_APPLICATIONS_CREATED_BY_USER;
        }
    }
    getSearchResponsiblePersonUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_RESPONSIBLEPERSON:
                return ApiApplicationSearchConstants.FUNCTION_GET_CM_APPLICATIONS_BY_RESPONSIBLEPERSON;
        }
    }
    generateInvoiceReportService(applicationId, invoiceID, canDownloadInPortal = false) {
        const params = {
            invoiceId: invoiceID,
            canDownloadInPortal
        };
        return this.http.get(`${ApiCemeteryConstants.URL}/${applicationId}/${ApiCemeteryConstants.FUNCTION_GET_GENERATE_INVOICE}`, { responseType: "blob", params });
    }
    getRequiredDocumentsChecklist(applicationId, jobId) {
        const params = {
            $filter: jobId
        };
        return this.http.get(`${ApiCemeteryConstants.URL}/${applicationId}/${ApiCemeteryConstants.FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getExternalLinks(moduleId, jobId, category) {
        var params = {
            jobId: jobId,
            category: category
        };
        return this.http.get(`${ApiCemeteryConstants.URL}/${moduleId}/${ApiCemeteryConstants.FUNCTION_GET_EXTERNAL_LINKS}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    buildCMSExtendedEndpoint() {
        return `${ApiApplicationSearchConstants.FUNCTION_GET_CM_APPLICATIONS_WITH_FAMILIES}`
            + `${ApiProxyConstants.QUERY_PREFIX}`
            + `${ApplicationSearchConstants.MODULE_ID}=${this.appControllerService.selectedModuleID}`;
    }
    initForm() {
        this.form = new FormGroup({
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
                // applicantAgentRecipient: new FormControl(null, [Validators.required]),
                copyApplicantDetails: new FormControl(null),
                markApplicantAgentAsNotApplicable: new FormControl(null)
            }),
            noteForm: new FormGroup({
                newNote: new FormControl(null),
                notes: new FormArray([]),
            }),
            detailsForm: new FormGroup({
                description: new FormControl(null, [Validators.required]),
                cemeteryId: new FormControl(null),
                burialType: new FormControl(null, [Validators.required]),
                burialDate: new FormControl(null),
                funeralParlour: new FormControl(null, [Validators.required]),
                pauperDecision: new FormControl(null),
                pauperDecisionDate: new FormControl(null),
                isDocumentationComplete: new FormControl(null),
                referenceNumber: new FormControl(null),
            }),
            familyForm: new FormGroup({
                family: new FormControl({ recipients: [] })
            }),
            deceasedForm: new FormGroup({
                deceasedNames: new FormArray([], [Validators.minLength(1)]),
                sex: new FormControl(null, [Validators.required]),
                nationality: new FormControl(SharedConstants.DEFAULT_COUNTRY, [Validators.required]),
                identificationType: new FormControl(null, [Validators.required]),
                idNumber: new FormControl(null, [Validators.required]),
                dateOfBirth: new FormControl(null, [Validators.required]),
                dateOfDeath: new FormControl(null),
                placeOfBirth: new FormControl(null, [Validators.required]),
                placeOfDeath: new FormControl(null),
                provinceOfDeath: new FormControl(null),
                maidenName: new FormControl(null),
                burialOrderNumber: new FormControl(null, [Validators.required]),
                serialNumber: new FormControl(null),
                verticalPosition: new FormControl(null, [Validators.required]),
                nameOfUndertaker: new FormControl(null)
            })
        });
    }
    getEntityColumn(searchColumn) {
        switch (searchColumn) {
            case SharedConstants.SEARCH_BY_DEFAULT:
                return SharedConstants.SEARCH_BY_DEFAULT;
            case SharedConstants.DASHBOARD_FILTERS.LatestApplications:
                return SharedConstants.DASHBOARD_FILTERS.LatestApplications;
            case SharedConstants.DASHBOARD_FILTERS.OverdueApplications:
                return SharedConstants.DASHBOARD_FILTERS.OverdueApplications;
            case SharedConstants.DASHBOARD_FILTERS.OpenApplications:
                return SharedConstants.DASHBOARD_FILTERS.OpenApplications;
            case SharedConstants.DASHBOARD_FILTERS.ClosedApplications:
                return SharedConstants.DASHBOARD_FILTERS.ClosedApplications;
            case SharedConstants.DASHBOARD_FILTERS.TotalApplications:
                return SharedConstants.DASHBOARD_FILTERS.TotalApplications;
            case SharedConstants.DASHBOARD_FILTERS.ApplicationStatus:
                return this.statusColumn;
            default:
                return this.searchQueryLookup.get(searchColumn);
        }
    }
    buildApplication() {
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeRecipientProperties(applicantFormValue);
        const copyApplicantDetails = this.form.get("applicantForm").get("copyApplicantDetails").value;
        const markApplicantAgentAsNotApplicable = this.form.get("applicantForm").get("markApplicantAgentAsNotApplicable").value;
        let applicantAgent = null;
        const applicantAgentRecipientFormControl = this.form.get("applicantForm").get("applicantAgentRecipient");
        if (copyApplicantDetails) {
            this.recipientSelectService.setRecipient(applicantFormValue, true, applicantAgentRecipientFormControl, true);
        }
        if (copyApplicantDetails === true || markApplicantAgentAsNotApplicable === true) {
            const applicantAgentFormValue = this.form
                .get("applicantForm")
                .get("applicantAgentRecipient").value;
            applicantAgent = RecipientUtils.removeRecipientProperties(applicantAgentFormValue);
        }
        const funeralParlourFormValue = this.form.get("detailsForm").get("funeralParlour").value;
        const funeralParlour = RecipientUtils.removeRecipientProperties(funeralParlourFormValue);
        const familyValue = this.form.get("familyForm").get("family").value;
        let family = [];
        if (familyValue !== undefined && familyValue !== null && familyValue.hasOwnProperty("recipients")) {
            family = familyValue.recipients;
            family.forEach((familyMember) => {
                familyMember = RecipientUtils.removeRecipientProperties(familyMember);
            });
        }
        const deceasedNames = [];
        const namesArray = this.form.get("deceasedForm").get("deceasedNames");
        namesArray.controls.forEach((item) => {
            const deceasedName = {
                name: item.get("name").value,
                surname: item.get("surname").value,
                startDate: item.get("startDate").value
            };
            deceasedNames.push(deceasedName);
        });
        let idType = this.form.get("deceasedForm").get("identificationType").value ? this.form.get("deceasedForm").get("identificationType").value.value : null;
        let sex = this.form.get("deceasedForm").get("sex").value ? this.form.get("deceasedForm").get("sex").value.value : null;
        let verticalPosition = this.form.get("deceasedForm").get("verticalPosition").value ? this.form.get("deceasedForm").get("verticalPosition").value.value : null;
        const deceased = {
            sex: sex,
            nationality: this.form.get("deceasedForm").get("nationality").value,
            idType: idType,
            idNumber: this.form.get("deceasedForm").get("idNumber").value,
            burialOrderNumber: this.form.get("deceasedForm").get("burialOrderNumber").value,
            serialNo: this.form.get("deceasedForm").get("serialNumber").value,
            verticalPosition: verticalPosition,
            dateOfBirth: this.form.get("deceasedForm").get("dateOfBirth").value,
            dateOfDeath: this.form.get("deceasedForm").get("dateOfDeath").value,
            placeOfBirth: this.form.get("deceasedForm").get("placeOfBirth").value,
            placeOfDeath: this.form.get("deceasedForm").get("placeOfDeath").value,
            maidenName: this.form.get("deceasedForm").get("maidenName").value,
            undertaker: this.form.get("deceasedForm").get("nameOfUndertaker").value,
            provinceOfDeath: this.form.get("deceasedForm").get("provinceOfDeath").value,
            deceasedNames
        };
        const application = {
            burialDate: this.form.get("detailsForm").get("burialDate").value,
            type: this.form.get("detailsForm").get("burialType").value.value,
            cemeteryId: this.form.get("detailsForm").get("cemeteryId").value.cemeteryId,
            cemeteryName: this.form.get("detailsForm").get("cemeteryId").value.cemeteryName,
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appController.selectedModuleID),
            description: this.form.get("detailsForm").get("description").value,
            funeralParlour: [funeralParlour],
            family,
            deceased: [deceased],
            applicant: [applicant],
            //applicantAgent: [],
            notes: [],
            applicantAgentNa: !markApplicantAgentAsNotApplicable
        };
        if (copyApplicantDetails === true || markApplicantAgentAsNotApplicable === true) {
            application.applicantAgent.push(applicantAgent);
        }
        const notesArray = this.form.get("noteForm").get("notes");
        notesArray.controls.forEach((item) => {
            const note = {
                note: item.get("note").value,
            };
            application.notes.push(note);
        });
        return application;
    }
    initializeBuildingUseSearchOptions() {
    }
    doSearchApplicationsByCreatedByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsCreatedByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiCemeteryConstants.URL}/${jobId}/${ApiCemeteryConstants.FUNCTION_APPLICATION_TYPES}`;
        return this.http.get(url, { params });
    }
    saveDraftApplication() {
    }
    getDraftApplication() {
        return null;
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router },
        { type: RecipientSelectService },
        { type: ActivatedRoute }
    ];
};
CemeteryStrategyService = CemeteryStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root",
    }),
    AutoUnsub()
], CemeteryStrategyService);
export { CemeteryStrategyService };
